/**
 * OnboardingComplete Component
 * Success screen after completing onboarding
 */

import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'
import { CheckCircle2, ArrowRight } from 'lucide-react'

export function OnboardingComplete() {
  const navigate = useNavigate()

  return (
    <div className="text-center py-8">
      <div className="mb-6">
        <div className="h-20 w-20 rounded-full bg-green-500/10 flex items-center justify-center mx-auto mb-4">
          <CheckCircle2 className="h-10 w-10 text-green-500" />
        </div>
        <h2 className="text-2xl font-bold mb-2">You're All Set!</h2>
        <p className="text-muted-foreground">
          Great job! You've created your first workspace, project, and task.
        </p>
      </div>

      <div className="bg-muted/50 rounded-lg p-6 mb-6 space-y-3">
        <h3 className="font-semibold text-sm">What's Next?</h3>
        <ul className="text-sm text-muted-foreground space-y-2 text-left">
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            <span>Create more projects to organize your work</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            <span>Add more tasks and track your progress</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            <span>Invite team members from your Workspace Settings</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            <span>Use messages to communicate with your team</span>
          </li>
        </ul>
      </div>

      <Button size="lg" className="w-full" onClick={() => navigate('/')}>
        Go to Dashboard
        <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
    </div>
  )
}
